import { schema } from "normalizr";
import Catalog from "./catalog";

export default new schema.Array(Catalog);
